import React from "react";

export const EquipmentAnalysisConfig = {
  settings: {
    layout: {
          config: {
            rightSidePanel: {
                display: false
            }
          }
    }
  },
  routes: [
    {
          path: "/analytics/equipment-analysis",
          component: React.lazy(() => import("./EquipmentAnalysis"))
    }
  ]
};
